import { useProject } from './useProject';

export const useNatureUnitVariant = () => {
  const project = useProject().data;

  return project.natureUnitVariant;
};
